module.exports = __webpack_public_path__ + "img/Market Research 2.bc240dc9.png";